<template>
  <div class="print-d1" ref="print" style="margin: auto;">
    <div class="print-div" v-for="(v,i) in data" :key="i">
      <div class="print-content">
        <!-- <div class="info-title">
          <div style="font-size: 20px;">{{v.CustomerName}}</div>
        </div> -->
        <div class="info_no">
          <div class="info-item">
            <div style="font-size: 20px;">{{v.CustomerName}}</div>
            <div style="font-size: 16px;">商品: {{v.GoodsName}}</div>
            <div style="font-size: 16px;">数量: {{v.Quantity}}({{v.UnitName}})</div>
            <div style="font-size: 16px;">规格: {{v.Model}}</div>
            <div style="font-size: 16px;">单据日期: {{$commonJs.toDateString(v.DocDate)}}</div>
          </div>
          <!-- <el-image :src="require('@/assets/store.jpg')" fit="contain"></el-image> -->
        </div>
        <div class="info_no">
          <div style="font-size: 16px;">备注: {{v.Remark}}</div>
        </div>
      </div>
      <div style="clear:both;"></div>
    </div>
    <div slot="footer" class="handle-button oo-print">
      <el-button icon="el-icon-printer" size="mini" type="primary" @click="print">打印</el-button>
    </div>
  </div>
</template>
<script>
const max = 4;

export default {
  data() {
    return {
      api: require("@/api/sale/saDoc").default,
      sApi: require("@/api/sale/saDoc").default,
      data: {
        SaleDeliveryNumber: "",
        Salesman: "",
        Driver: "",
        SendTime: "",
        Remarks: "",
        Details: [],
        Receipts: [],
      },
      leave: 0,
      nolist: [],
      goods: [],
    };
  },
  beforeMount() {
    var param = this.$route.query;
    this.api.PrintDetailsList(param).then((res)=>{
      if(res.Code==0){
        this.data=res.Data;
      }

    });
    //this.data = JSON.parse(sessionStorage.getItem("quality"));


    return;
    var sid = this.$route.query.sid.split(",");
    sid.forEach((e) => {
      this.api.info(e).then((res) => {
        res.Data.total = 0;
        res.Data.Goods.forEach((m) => {
          res.Data.total += m.Amount;
        });
        res.Data.cTotal = toPrice(res.Data.total);
        this.data.push(res.Data);
      });

      this.sApi.getGoodsList(e).then((res) => {
        // this.data = res.Data
        res.Data.forEach((item) => {
          this.count(item, true);
        });
        this.goods = res.Data;
        return;
        var dl = [];
        res.Data.forEach((e) => {
          dl.push({
            // line: Math.ceil(e.DetailModel.length/6)+1,
            // num: e.DetailModel.length
          });
        });
        var nolist = [];
        
        // index显示数据的下标 numlist下标范围 pl剩余未显示下标范围 ll剩余未显示行数(包含表头) e.line包含表头
        // dl.forEach((e,index) => {
        for (var index = 0; index < dl.length; index++) {
          var e = dl[index];
          if (index == 0) {
            if (e.line > max) {
              nolist.push({
                index: [0],
                numlist: [0, (max - 1) * 6 - 1],
                pl: [(max - 1) * 6, e.num - 1],
                ll: countLine((max - 1) * 6, e.num) + 1,
              });
            } else {
              var limit = max - e.line;
              if (dl.length > 1 && limit >= 2) {
                //显示下一个
                if (dl[index + 1].line > limit) {
                  //部分显示
                  nolist.push({
                    index: [0, 1],
                    numlist: [0, e.num - 1, 0, (limit - 1) * 6 - 1],
                    pl: [(limit - 1) * 6, dl[index + 1].num - 1],
                    ll: countLine((limit - 1) * 6, dl[index + 1].num) + 1,
                    self: true,
                  });
                } else {
                  //显示全部
                  nolist.push({
                    index: [0, 1],
                    numlist: [0, e.num - 1, 0, dl[index + 1].num - 1],
                    pl: [],
                    ll: 1,
                  });
                  dl.splice(index + 1, 1);
                }
              } else {
                nolist.push({
                  index: [0],
                  numlist: [0, e.num - 1],
                  pl: [],
                  ll: 1,
                });
              }
            }
          } else {
            if (nolist[index - 1].ll > 1) {
              // 上一个有剩余
              var limit = max - nolist[index - 1].ll;
              if (nolist[index - 1].self) {
                //剩余的是本身
                if (dl.length <= index + 1) {
                  
                  nolist.push({
                    index: [index],
                    numlist: [nolist[index - 1].pl[0], e.num - 1],
                    pl: [],
                    ll: 1,
                  });
                } else if (limit >= 2) {
                  if (dl[index + 1].line > limit) {
                    

                    nolist.push({
                      index: [index, index + 1],
                      numlist: [
                        nolist[index - 1].pl[0],
                        e.num - 1,
                        0,
                        (limit - 1) * 6 - 1,
                      ],
                      pl: [(limit - 1) * 6, dl[index + 1].num - 1],
                      ll: 1,
                      self: true,
                    });
                  } else {
                    

                    nolist.push({
                      index: [index, index + 1],
                      numlist: [
                        nolist[index - 1].pl[0],
                        e.num - 1,
                        0,
                        dl[index + 1].num - 1,
                      ],
                      pl: [],
                      ll: 1,
                    });
                    dl.splice(index + 1, 1);
                  }
                } else {
                  

                  nolist.push({
                    index: [index],
                    numlist: [nolist[index - 1].pl[0], e.num - 1],
                    pl: [],
                    ll: 1,
                  });
                }
              } else {
                if (limit > 2) {
                  // 显示本身
                  if (limit >= e.line) {
                    // 显示部分本身
                    nolist.push({
                      index: [index - 1, index],
                      numlist: [
                        nolist[index - 1].pl[0],
                        nolist[index - 1].pl[1],
                        0,
                        e.num - 1,
                      ],
                      pl: [],
                      ll: 1,
                    });
                  } else {
                    // 完全显示本身
                    nolist.push({
                      index: [index - 1, index],
                      numlist: [
                        nolist[index - 1].pl[0],
                        nolist[index - 1].pl[1],
                        0,
                        (limit - 1) * 6 - 1,
                      ],
                      pl: [(limit - 1) * 6 - 1, e.num - 1],
                      ll: countLine((limit - 1) * 6, e.num) + 1,
                    });
                  }
                } else {
                  //不显示本身
                  nolist.push({
                    index: [index - 1],
                    numlist: [nolist[index - 1].pl[0], nolist[index - 1].pl[1]],
                    pl: [0, e.num - 1],
                    ll: e.line,
                  });
                  nolist.push({
                    index: [index],
                    numlist: [0, e.num - 1],
                    pl: [],
                    ll: 1,
                  });
                }
              }
            } else {
              // 上一个无剩余
              if (e.line > max) {
                // 显示部分本身
                nolist.push({
                  index: [index],
                  numlist: [0, (max - 1) * 6 - 1],
                  pl: [(max - 1) * 6, e.num - 1],
                  ll: countLine((max - 1) * 6, e.num) + 1,
                });
              } else {
                // 完全显示本身
                if (index + 1 < dl.length) {
                  var limit3 = max - e.line;
                  if (limit3 >= 2) {
                    //显示下一个
                    if (dl[index + 1].line <= limit3) {
                      //完全显示下一个
                      nolist.push({
                        index: [index, index + 1],
                        numlist: [0, e.num - 1, 0, dl[index + 1].num - 1],
                        pl: [],
                        ll: 1,
                      });
                      dl.splice(index + 1, 1);
                    } else {
                      //部分显示下一个
                      nolist.push({
                        index: [index, index + 1],
                        numlist: [0, e.num - 1, 0, (limit3 - 1) * 6 - 1],
                        pl: [(limit3 - 1) * 6, dl[index + 1].num - 1],
                        ll: countLine((limit3 - 1) * 6, dl[index + 1].num) + 1,
                        self: true,
                      });
                    }
                  } else {
                    //不显示下一个
                    nolist.push({
                      index: [index],
                      numlist: [0, e.num - 1],
                      pl: [],
                      ll: 1,
                    });
                  }
                } else {
                  //不显示下一个
                  nolist.push({
                    index: [index],
                    numlist: [0, e.num - 1],
                    pl: [],
                    ll: 1,
                  });
                }
              }
            }
          }
        }
        // })
        nolist.forEach((n) => {
          n.total = 0;
          n.index.forEach((m) => {
            // n.total += this.data.Details[m].QuantityMaterial*this.data.Details[m].PriceMaterial;
          });
          n.cTotal = toPrice(n.total);
        });
        
        this.nolist = nolist;
      });
    });
    // this.data.forEach(n => {
    //   n.total = 0;
    //   n.Goods.forEach(m => {
    //     n.total += m.Amount;
    //   })
    //   n.cTotal = toPrice(n.total);
    // })
  },
  methods: {
    count(row, keep = false) {
      let price = row.Price ? Number(row.Price) : 0;
      let dis = row.Discount ? Number(row.Discount) : 100;
      let qua = row.Quantity ? Number(row.Quantity) : 0;
      let rate = row.TaxRate ? Number(row.TaxRate) : 0;
      let ref = row.ReferenceCost ? Number(row.ReferenceCost) : 0;
      if (row.T !== 0 && !keep) {
        row.T = 1;
      }
      row.Amount = (price * qua - dis / 100).toFixed(2);
      if (row.Amount < 0) {
        row.Amount = 0;
      }
      row.TaxAmount = ((row.Amount * rate) / 100).toFixed(2) || 0;
      row.GrossProfit = (row.Amount - qua * ref).toFixed(2);
    },
    print() {
      window.print();
    },
  },
};
function countLine(start, end) {
  return Math.ceil((end - start) / 6);
}
function toPrice(n) {
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
    return ""; //判断数据是否大于0
  }

  var unit = "千百拾亿千百拾万千百拾元角分",
    str = "";
  n += "00";

  var indexpoint = n.indexOf("."); // 如果是小数，截取小数点前面的位数

  if (indexpoint >= 0) {
    n = n.substring(0, indexpoint) + n.substr(indexpoint + 1, 2); // 若为小数，截取需要使用的unit单位
  }

  unit = unit.substr(unit.length - n.length); // 若为整数，截取需要使用的unit单位
  for (var i = 0; i < n.length; i++) {
    str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i); //遍历转化为大写的数字
  }

  return str
    .replace(/零(千|百|拾|角)/g, "零")
    .replace(/(零)+/g, "零")
    .replace(/零(万|亿|元)/g, "$1")
    .replace(/(亿)万|壹(拾)/g, "$1$2")
    .replace(/^元零?|零分/g, "")
    .replace(/元$/g, "元整"); // 替换掉数字里面的零字符，得到结果
}
</script>
<style media="printContent" scoped>
@page {
  size: auto; /* auto is the initial value /
margin: 3mm; / this affects the margin in the printer settings */
}

html {
  background-color: #ffffff;
  margin: 0px; /* this affects the margin on the html before sending to printer */
}

body {
  border: solid 1px rgba(255, 255, 255, 0);
  /* margin: 10mm 15mm 10mm 15mm; margin you want for the content */
}
</style>
<style lang="scss" scoped>
.print-d1 {
  width: 380px;
  padding-top: 10px;
}
.footer {
  padding-left: 25px;
}
.c-print-dialog {
  font-family: "宋体";
}
.print-div {
  width: 310px;
  margin: auto;
  border: 1px #aaa solid;
  padding: 10px 20px;
  // margin: 0px 5px;
}
//去除最后一张空白
.print-div + .print-div {
  margin-top: 20px;
}
.print-content {
  padding: 0;
  position: relative;
  // padding-bottom: 10px;
  .info-title {
    font-size: 20px;
    font-weight: bold;
    height: 52px;
  }
  .info_no {
    display: flex;
    align-items: flex-end;
    div {
      font-weight: bold;
    }
    .info-item {
      flex: 1;
      line-height: 26px;
    }
    .el-image {
      width: 100px;
    }
  }
}
.handle-button {
  position: fixed;
  top: 20px;
  right: 10%;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
@media print {
  body,
  #app {
    overflow: unset !important;
    min-width: 0 !important;
    margin: 0 !important;
  }
  /deep/ .no-print {
    display: none;
  }
  .print-d1 {
    width: 100%;
    padding: 0px;
  }
  .no-print {
    display: none;
  }
  .el-dialog__body {
    padding: 0 !important;
  }

  .print-div {
    height: 100%;
    border: none;
  }
}
</style>